module.exports = __webpack_public_path__ + "img/img2.cb218e1a.png";